import Vue from 'vue'
import Router from 'vue-router'
import productRouter from '@/router/moudles/productRouter.js'
import institutionRouter from '@/router/moudles/institutionRouter.js'
import marketServiceRouter from '@/router/moudles/marketServiceRouter.js'
import accountRouter from '@/router/moudles/accountRouter.js'
import otherRouter from '@/router/moudles/otherRouter.js'

Vue.use(Router)

const routes = [
  {path: '*', name: '创投股权与私募基金份额报价转让平台', component: () => import('@/views/index')},
  {path: '/test', name: 'test', component: () => import('@/views/test')},
  ...productRouter,
  ...institutionRouter,
  ...marketServiceRouter,
  ...accountRouter,
  ...otherRouter
]
const router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.name
  window._axiosPromiseArr.forEach((el, index) => {
    el.cancel() // 路由跳转之前，中止请求
    //  重置 window._axiosPromiseArr
    delete window._axiosPromiseArr[index]
  })
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js